import {Record, Map, List} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

interface Sender {
    id: string;
    image: string;
    recipient: string;
    subtitle: string;
    title: string;
}

export interface BlockedSender {
    loginId: string;
    sender: Sender;
}

export interface FeedSettingsStateProps {
    readonly loading: boolean;
    readonly unblocking: Map<string, boolean>;
    readonly blocked: List<BlockedSender>;
}

export class FeedSettings extends Record<FeedSettingsStateProps>({
    loading: false,
    unblocking: Map(),
    blocked: List(),
}) {}

export default makeReducer<FeedSettings>(
    [
        match(Actions.fetchBlocked, state =>
            state.merge({
                loading: true,
            }),
        ),
        match(Actions.fetchBlockedSuccess, (state, {payload}) =>
            state.merge({
                loading: false,
                blocked: payload.blocked,
            }),
        ),
        match(Actions.fetchBlockedFailed, state =>
            state.merge({
                loading: false,
            }),
        ),
        match(Actions.unblockSender, (state, {payload}) =>
            state.merge({
                unblocking: state.unblocking.set(payload.id, true),
            }),
        ),
        match(Actions.unblockSenderSuccess, (state, {payload}) =>
            state.merge({
                unblocking: state.unblocking.set(payload.id, false),
                blocked: state.blocked.delete(state.blocked.findIndex(b => b.loginId === payload.id)),
            }),
        ),
        match(Actions.unblockSenderFailed, (state, {payload}) =>
            state.merge({
                unblocking: state.unblocking.set(payload.id, false),
            }),
        ),
    ],
    new FeedSettings(),
);
